import { clientAxios } from '../../../hooks/useAxios';

export const applySignature = async params => {
  const { cartId, quote, shippingMethodId, methods, payload } = params;
  try {
    const response = await clientAxios.request({
      method: 'POST',
      url: `/plugin/customerSignature/insert/${cartId}`,
      data: { paymentMethodPayload: payload?.data, quote },
    });
    return {
      success: true,
      cart: response?.data?.cart,
      cartTotals: response?.data?.cartTotals,
      shipMethods: methods,
      currentMethod: shippingMethodId,
      paymentMethodData: response?.data?.paymentMethodData,
    };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data,
    };
  }
};

export const removeSignature = async params => {
  const { cartId, quote, shippingMethodId, methods, payload } = params;
  try {
    const response = await clientAxios.request({
      method: 'POST',
      url: `plugin/customerSignature/remove/${cartId}`,
      data: { paymentMethodPayload: payload?.data, quote },
    });
    return {
      success: true,
      cart: response?.data?.cart,
      cartTotals: response?.data?.cartTotals,
      shipMethods: methods,
      currentMethod: shippingMethodId,
      paymentMethodData: response?.data?.paymentMethodData,
    };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data,
    };
  }
};
